<template>
  <div class="event-box" @click="openSelectChatPopup">
    <div class="ev-txt-wrap">
      <p>{{ t('find_right_interpretation') }}</p>
      <span>{{ t('help_right_interpretation') }}</span>
    </div>
    <div class="ev-img">
      <img :src="getAssetImageUrl('app/deco/learn-visual.svg')" alt="" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { I18nT } from 'vue-i18n';

import BottomSheet from '@/components/domains/mobile/common/PopupBottomSheet.vue';
import InterpretationList from '@/components/domains/mobile/InterpretationList.vue';
import { usePopupStore } from '@/stores/popup';
import { TypeCall } from '@/types/common';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();
const router = useRouter();

const popupStore = usePopupStore();

const selectedChatType = ref<TypeCall | null>(null);

const openSelectChatPopup = () => {
  const popupId = popupStore.open(BottomSheet, {
    title: h(
      I18nT,
      { keypath: 'select_interpretation_title' },
      {
        interpretation: () => h('span', { class: 'primary' }, t('label_interpretation')),
      }
    ),
    contentSlot: h(InterpretationList, {
      modelValue: selectedChatType.value,
      'onUpdate:modelValue': (type) => {
        selectedChatType.value = type;
      },
    }),
    showHandleBar: true,
    confirmButton: {
      text: t('button_start'),
      action: () => {
        if (selectedChatType.value) {
          popupStore.close(popupId);
          goToCreateChat();
        }
      },
    },
  });
};

const goToCreateChat = () => {
  router.push(`/app/chat/new/${selectedChatType.value?.toLowerCase()}`);
};
</script>

<style scoped lang="scss">
.event-box {
  margin-top: 12px;
  border-radius: $size-m;
  background: #fff;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ev-txt-wrap {
    p {
      font-weight: 600;
      margin-bottom: 0.125rem;
    }
    span {
      font-size: $font-size-xs;
      color: $color-gray-200;
    }
  }
}
</style>
